export default __webpack_public_path__ + "static/media/chat.eb75e2f6.jpeg";